module.exports = __webpack_public_path__ + "media/images/sec_6-2-3920211c79b0fc7c40f39d561044394a.png";